export enum ProductionFSEvent{
    SeeInPlanningLinkClick = 'SeeInPlanningLinkClick'
}